import { get } from '../../Utils/objectHelpers';

export const getLocale = (state) => get(state, (s) => s.user.user.locale) || '';
